import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { clinicInvoiceTermsDataSource } from 'infrastructure/data-sources/clinic-invoice-terms';

import type { IClinicInvoiceTermItem } from 'infrastructure/data-sources/clinic-invoice-terms';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';

type Options = IBaseSelectBoxOption<
  IClinicInvoiceTermItem['id'],
  IClinicInvoiceTermItem
>[];

interface IProps extends Omit<IBaseSelectBoxProps, 'options'> {}

const ClinicInvoiceTermSelectBox: React.FC<IProps> = (props) => {
  const dataSource = useMemo(() => clinicInvoiceTermsDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default ClinicInvoiceTermSelectBox;
